<template>
    <div class="custom-tooltips">
        <div class="tooltips d-grid-12" :class="{ scale_1: tooltipsShow }">
            <div class="grid-cspan-11">
                <slot name="tooltips"></slot>
            </div>
            <div class="grid-cspan-1">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M18 6L6 18"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M6 6L18 18"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </div>
        </div>
        <div class="content" @mouseenter="toogleTooltips" @mouseleave="toogleTooltips">
            <slot name="content"></slot>
        </div>
        <!-- <div class="arrow" :class="{ scale_1: tooltipsShow }"></div> -->
    </div>
</template>
<script>
export default {
    name: "SOTooltips",
    data() {
        return {
            tooltipsShow: false,
        };
    },
    methods: {
        toogleTooltips() {
            this.tooltipsShow = !this.tooltipsShow;
        },
    },
};
</script>

<style scoped>
.custom-tooltips {
    position: relative;
}

.custom-tooltips .tooltips,
.custom-tooltips .arrow {
    --scale: 0;
    --tooltip-color: #333;
    --arrow-size: 10px;

    position: absolute;
    top: -0.25rem;
    left: 50%;
    transform: translateX(-50%) translateY(var(--translate-y, 0)) scale(var(--scale));
    transition: 150ms transform;
    transform-origin: bottom center;
}

.custom-tooltips .tooltips {
    --translate-y: calc(-100% - var(--arrow-size));
    color: white;
    border-radius: 0.6rem;
    text-align: center;
    padding: 0.6rem;
    width: max-content;
    max-width: 92vw;
    background: var(--tooltip-color);
}

.custom-tooltips .scale_1 {
    --scale: 1;
}

/* .custom-tooltips .arrow {
    --translate-y: calc(-1.02 * var(--arrow-size));
    content: "";
    display: none;
    border: var(--arrow-size) solid transparent;
    border-top-color: var(--tooltip-color);
    transform-origin: top center;
} */
</style>
